import React, { useState } from 'react';
import { authApi } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useToast } from './Toast';
import './ChangePasswordModal.css';

interface Props {
  onClose: () => void;
}

const ChangePasswordModal: React.FC<Props> = ({ onClose }) => {
  const { user } = useAuth();
  const { showToast } = useToast();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmPassword) {
      showToast('Veuillez remplir tous les champs', 'error');
      return;
    }
    if (newPassword !== confirmPassword) {
      showToast('Les mots de passe ne correspondent pas', 'error');
      return;
    }
    if (newPassword.length < 4) {
      showToast('Le nouveau mot de passe doit contenir au moins 4 caractères', 'error');
      return;
    }
    if (!user?.user_name) {
      showToast('Utilisateur non identifié', 'error');
      return;
    }

    setSaving(true);
    try {
      await authApi.changePassword(user.user_name, oldPassword, newPassword);
      showToast('Mot de passe changé avec succès', 'success');
      onClose();
    } catch (err: any) {
      showToast(err.response?.data?.error || 'Erreur lors du changement de mot de passe', 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cpw-overlay" onClick={onClose}>
      <div className="cpw-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cpw-header">
          <h3>Changer le mot de passe</h3>
          <button className="cpw-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="cpw-field">
            <label>Mot de passe actuel</label>
            <div className="cpw-input-wrap">
              <input
                type={showOld ? 'text' : 'password'}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button type="button" className="cpw-toggle" onClick={() => setShowOld(!showOld)}>
                {showOld ? '🙈' : '👁'}
              </button>
            </div>
          </div>
          <div className="cpw-field">
            <label>Nouveau mot de passe</label>
            <div className="cpw-input-wrap">
              <input
                type={showNew ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
              <button type="button" className="cpw-toggle" onClick={() => setShowNew(!showNew)}>
                {showNew ? '🙈' : '👁'}
              </button>
            </div>
          </div>
          <div className="cpw-field">
            <label>Confirmer le nouveau mot de passe</label>
            <div className="cpw-input-wrap">
              <input
                type={showConfirm ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
              <button type="button" className="cpw-toggle" onClick={() => setShowConfirm(!showConfirm)}>
                {showConfirm ? '🙈' : '👁'}
              </button>
            </div>
          </div>
          <div className="cpw-actions">
            <button type="button" className="cpw-btn cpw-btn-cancel" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="cpw-btn cpw-btn-save" disabled={saving}>
              {saving ? 'En cours...' : 'Changer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
